import { ItemTemplate } from "./ItemTemplate";

export class NumItemTemplate extends ItemTemplate {
    /**
    * Vytvoří hlavní element, do kterého se bude vkládat obsah jednotlivých buněk
    */
    protected override _createContentElement(): HTMLElement {
        const element = document.createElement("span");
        element.classList.add("number");

        return element;
    }
}
